import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import '@chess/api-insights/charts.css';
import { OpeningsPerformance } from './OpeningsPerformance.tsx';
import { RankingAggregator } from './RankingAggregator.ts';

// The openings screen's ranking: the last 30 days' openings, ranked by its
// own aggregator (`RankingAggregator`, run by the game store), rendered by
// `OpeningsPerformance` and recomputed whenever the store changes (a game
// imported, a scan completed). The games are scanned automatically
// (plugin shared-scan; the header's import button shows the progress); under
// the tables a muted line says how many openings wait for scans. A click on an opening opens the library filtered to it and its
// colour (`libraryLink`); the library covers the same 30 days, so the counts
// match.
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  const aggregator = new RankingAggregator();
  registerAggregator(getApi, aggregator);

  const Panel: React.FC = () => {
    const { result } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(
      () => libraryLink((path) => navigate(path), 'opening'),
      [navigate],
    );
    return <OpeningsPerformance ranking={result} link={link} />;
  };
  // Under the History section's cards, within their width (screen-openings).
  app.registerExtension('openings.history', Panel, { order: 10 });
}
